import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export default function BarChart({ masterData }: any) {
  // Extracting the data from masterData

  // Custom color scheme for the bars
  const colors = ['#FF9900', '#33CC33', '#FF3366']

  // Configuration for the bar chart

  const options = {
    chart: {
      type: 'column', // Bar chart type
      backgroundColor: 'black',
    },
    title: {
      text: 'Employee Leave Chart',
      style: {
        color: 'white',
      },
    },
    xAxis: {
      categories: [
        'PTO Leaves',
        'Emergency PTO',
        'Work from Home',
        'Loss Of Pay',
      ],
      labels: {
        style: {
          color: 'white',
        },
      },
    },
    yAxis: {
      title: {
        text: 'Leave Count',
        style: {
          color: 'blue',
        },
      },
      labels: {
        style: {
          color: 'white',
        },
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: 'Leave Count',
        data: [
          masterData?.[0]?.total_pto_leaves,
          masterData?.[0]?.total_emergency_pto_leaves,
          masterData?.[0]?.total_work_from_home,
          masterData?.[0]?.total_loss_of_pay,
        ],
        colors: colors, // Use the custom color scheme
        dataLabels: {
          enabled: true,
          color: 'white',
          format: '{y}',
        },
      },
    ],
  }

  return (
    <div style={{ width: '50vw', margin: '0' }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}
